import { useConfigs } from './lib/config-context';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnFooter = ({
  columnData
}) => {
  const {
    renderFooter
  } = useConfigs();
  if (typeof renderFooter !== 'function') return null;
  return /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    padding: "200",
    "data-test-id": "cdb-column-footer",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle",
    borderBlockStartWidth: "100",
    backgroundColor: "fill-surface-default",
    children: renderFooter(columnData)
  });
};
export default ColumnFooter;